import { localStorageService } from '@/services/storage/storage.service';
import type { AuthTokens } from '@/types/auth';

const ACCESS_TOKEN_KEY = 'quiz_admin.access_token';
const REFRESH_TOKEN_KEY = 'quiz_admin.refresh_token';

/**
 * Narrow, purpose-built wrapper around the storage abstraction for auth
 * tokens specifically. Keeping this separate from `storage.service` means
 * the token persistence strategy (e.g. moving refresh tokens to an
 * httpOnly cookie set by the backend) can change without touching
 * feature code that only ever calls these functions.
 */
export const tokenStorage = {
  getAccessToken(): string | null {
    return localStorageService.getItem<string>(ACCESS_TOKEN_KEY);
  },

  getRefreshToken(): string | null {
    return localStorageService.getItem<string>(REFRESH_TOKEN_KEY);
  },

  setTokens(tokens: AuthTokens): void {
    localStorageService.setItem(ACCESS_TOKEN_KEY, tokens.accessToken);
    localStorageService.setItem(REFRESH_TOKEN_KEY, tokens.refreshToken);
  },

  clearTokens(): void {
    localStorageService.removeItem(ACCESS_TOKEN_KEY);
    localStorageService.removeItem(REFRESH_TOKEN_KEY);
  },
};
